import {
  ApiFormWrapper,
  FormError,
  FormSubmitButton,
} from "@holigral/shared/form"
import NameFields from "./NameFields"
import { useUpdateProfileMutation } from "./api"
import type { ProfilePayload } from "./model"
import { useMe } from "./selectors"
import { useT } from "@/i18n"

export default function Profile() {
  const { t } = useT()
  const [updateProfile] = useUpdateProfileMutation()
  const { data: me, isLoading } = useMe()

  if (isLoading) {
    return null
  }

  return (
    <ApiFormWrapper<ProfilePayload>
      defaultValues={{
        givenName: me?.givenName ?? "",
        familyName: me?.familyName ?? "",
      }}
      action={updateProfile}
      successMessage={t("profile.saved")}
    >
      <div className="mb-3">
        <NameFields />
      </div>
      <FormError />
      <FormSubmitButton>{t("save")}</FormSubmitButton>
    </ApiFormWrapper>
  )
}
